/* @ngInject */
export default function ($sce) {
	return (url) => {
		return $sce.trustAsResourceUrl(url);
	};
};


// WEBPACK FOOTER //
// ./src/js/filters/safeUrl.js